module.exports = __webpack_public_path__ + "img/logo_dentalia.59df5246.png";